'use client'

import useSetSearchParams from 'app/hooks/useSetSearchParams'
import { Button } from 'ui/button'

const LandingBannerButton = ({ landingButtonText, landingType }: { landingButtonText: any; landingType: string }) => {
    const { addParam } = useSetSearchParams()

    return (
        <div className='flex cursor-pointer gap-2 items-center font-semibold p-2 rounded-xl border-2 border-[#4676D8] w-fit mx-auto'>
            <Button
                onClick={() => addParam('landing_type', 'organisation')}
                className={`text-zinc-50 text-xs md:text-base md:px-4 md:py-2 px-2 py-1  rounded-md ${
                    landingType === 'organisation'
                        ? 'hover:landing_bg_gradient landing_bg_gradient'
                        : 'bg-transparent hover:bg-transparent'
                }`}
            >
                {landingButtonText.iAmFromAnOrganization}
            </Button>
            <Button
                onClick={() => addParam('landing_type', 'gamer')}
                className={`text-zinc-50 text-xs md:text-base md:px-4 md:py-2 px-2 py-1 rounded-md ${landingType === 'gamer' ? 'hover:landing_bg_gradient landing_bg_gradient' : 'bg-transparent hover:bg-transparent'}`}
            >
                {landingButtonText.iAmAGamer}
            </Button>
        </div>
    )
}

export default LandingBannerButton
